import { Component, forwardRef, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Company } from '@core/interfaces';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import * as _ from 'lodash';
import { debounceTime } from 'rxjs/operators';
import english from '../../../../../main/maintenances/i18n/en.json';
import spanish from '../../../../../main/maintenances/i18n/es.json';
import portuguese from '../../../../../main/maintenances/i18n/pt.json';
import { CompanyApi } from '../../../../api/companies.api';

export function ValidateAutocomplete(): object {
  return { required: true };
}

const INPUT_FIELD_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CompanyLegacyComponent),
  multi: true
};

@Component({
  selector: 'company-legacy',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss'],
  providers: [INPUT_FIELD_VALUE_ACCESSOR],
  encapsulation: ViewEncapsulation.None
})
export class CompanyLegacyComponent implements ControlValueAccessor, OnInit {
  @Input() public required: Boolean = false;
  @Input() public floatLabel: Boolean = true;
  @Input() public floatLabelText: string;
  @Input() public disabled: Boolean = false;
  @Input() public appearance = 'outline';
  public companies: Array<Company> = [];
  public inputValue = new FormControl();
  public hasSelectedCompany: boolean;
  public selectedCompany: Company;
  public loading = false;

  constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private companiesApi: CompanyApi
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({english, portuguese, spanish});
    if (this.required) { this.inputValue.setValidators(ValidateAutocomplete); }
  }

  ngOnInit(): void {
    if (this.disabled) { this.inputValue.disable(); }
    this.inputValue.valueChanges
      .pipe(debounceTime(500))
      .subscribe((value) => {
        this.companies = [];
        if (value) {
          this.searchCompanies({ name_contains: value, archived: false });
        }
      });
  }

  onChange: (_: any) => void = () => {};
  onTouched: (_: any) => void = () => {};

  searchCompanies(query?): void {
    this.loading = true;
    this.companiesApi.search(query).subscribe((result) => {
      this.loading = false;
      this.companies = result.items;
    });
  }

  writeValue(companyId: string): void {
    if (companyId) {
      this.companiesApi.searchOne(companyId).then((company) => {
        this.selectedCompany = company;
        this.hasSelectedCompany = true;
        this.inputValue.setErrors(null);
        this.inputValue.setValue(companyId);
      });
    } else {
      this.deselectCompany();
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setSelectedCompany(): void {
    if (this.inputValue.value) {
      this.onChange(this.inputValue.value);
      this.selectedCompany = _.find(this.companies, (company) => company.id === this.inputValue.value) as Company;
      this.hasSelectedCompany = true;
      this.inputValue.setErrors(null);
    }
  }

  deselectCompany(): void {
    this.onChange(null);
    this.inputValue.setValue(null);
    this.selectedCompany = null;
    this.hasSelectedCompany = false;
    this.inputValue.setErrors(null);
  }
}
